<template>
  <div class="main">
      <div class="top">
          <img src="../../static/img/oil_c.png" alt="">
      </div>
      <div class="login_box">
          <div class="login_title">
            车队管理员登录
          </div>
          <div class="form">
              <van-form @submit="onSubmit">
                <van-field
                    v-model="username"
                    name="username"
                    type="digit"
                    label="手机号"
                    placeholder="请输入手机号"
                    placeholder-class="placeholderStyle "
                    :rules="[{ required: true, message: '请输入手机号' }]"
                />
                <van-field
                    v-model="password"
                    type="password"
                    name="password"
                    label="密码"
                    placeholder="请输入密码"
                    :rules="[{ required: true, message: '请输入密码' }]"
                />
                <div style="margin: 16px;margin-top: 25px;font-size:14px;">
                    <van-button round block type="info" native-type="submit" size="small" text="登录"></van-button>
                </div>
                </van-form>
          </div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Form } from 'vant';
import { Field } from 'vant';
import { Dialog } from 'vant';

Vue.use(Form);
Vue.use(Field);
export default {
  name: 'margin',
  data () {
    return {
        username: '',
        password: '',
        openid:''
    }
  },
  beforeRouteEnter(to, from, next) {
    // from 就是上一个路由信息
    console.log(from.name)
    if (from.name != 'margin') {
      // 根据上一个路由信息决定是否自动登录
      // 这里可以添加自动登录的逻辑，例如调用登录接口
      next(vm => {
        // vm 就是组件实例
        vm.openid =  vm.GetRequest().openid
        if(vm.openid!=undefined&&vm.openid){
          vm.select()
        }
        
        console.log('可以自动登录，已设置默认密码');
      });
    }else{
      sessionStorage.setItem('autoLogin',0)
      sessionStorage.setItem('openid','')
    }
    next();
  },
  methods: {
    select(){
        this.$api.post(`orgapp/getOrgCustByOpenId?openId=${this.openid}`,{},response=>{
            console.log(response.data)
            var data = response.data
            if(data.code == 0){
                if(data.orgCust == ''){
                    sessionStorage.setItem('autoLogin',0)
                    sessionStorage.setItem('openid','')
                    return
                }
                this.username = data.orgCust.mobile
                this.password = data.orgCust.password
                sessionStorage.setItem('autoLogin',1)
                sessionStorage.setItem('openid',this.openid)
                this.onSubmit()
            }
        })
    },
    onSubmit(values) {
        console.log('submit', values);
        var data = {
             mobile:this.username,
            password:this.password,
            openId:this.openid
        }
        this.$api.post('orgapp/login',data,response=>{
          console.log(response.data)
          if (response.status >= 200 && response.status < 300) {
              console.log(response.data);
              var data = response.data
              if(data.msg=="success"){
                 sessionStorage.setItem('mobile',this.username)
                 this.$storage.set('token',data.token)
                 this.$router.push('/margin')
              }else{
                  Dialog.alert({
                    title: '标题',
                    message: '用户名或密码错误',
                }).then(() => {
                    // on close
                    this.username = ''
                    this.password = ''
                });
              }
          } else {

          }
      })
    },
    GetRequest() {
      //获取?后的参数
      var url = location.search; //获取url中"?"符后的字符串
      // var url = '?openid=oPt2m4kGd267PiKTkLgpU5fnAjBE'
      var strs;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
          // console.log(strs[i].split("="));
          if (strs[i].split("=")[2] == "") {
            theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1] + "=";
          }
        }
      }
      return theRequest;
    }

  },
  mounted(){

  }
}
</script>

<style scoped>
.van-button--small {
    height: 40px;
}
.van-cell {
    font-size: 16px!important;
    font-weight: 700!important;
}
.van-button--small {
    font-size: 14px;
    font-weight: 700;
}
.main {
    width: 80%;
    margin: auto;
}

.top {
    width: 100%;
    height: 170px;
    background-color: #00BFFF;
}
.top img {
    width: 100%;
    height: 100%;
}
.login_box {
    width: 100%;
    margin-top: 20px;
}
.login_title {
    text-align: center;
    color: #2FCBFF;
    border-bottom: 1px solid #2FCBFF;
    width:280px;
    margin: auto;
    font-size: 20px;
    height: 50px;
    line-height: 50px;
    font-weight: 700;
}
.form {
    width: 80%;
    margin: auto;
    margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue